import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Form, Icon } from 'semantic-ui-react';
import { paletteStyleDefault, markerPaletteStyle, pointMarkerPalette } from '../config/config';
import { exportImage } from '../../commons/utils';
import { StoreContext } from '../../store/StoreProvider';
import Act from '../../store/actions';

// handle exportImage button clicked
const exportImageHandler = async (element, { dispatch, resolution }) => {
	try {
		// turn on loading icon
		if (dispatch) dispatch({ type: Act.FILE_EXPORT_STATUS, fileExporting: true });
		const result = await exportImage(element, {
			fileName: `ptp-map-${new Date().getTime()}.png`,
			resolution: resolution || 3,
		});

		if (result.finish) {
			// turn off loading icon
			if (dispatch) dispatch({ type: Act.FILE_EXPORT_STATUS, fileExporting: false });
		}
	} catch (err) {
		// turn off loading icon
		if (dispatch) dispatch({ type: Act.FILE_EXPORT_STATUS, fileExporting: false });
		// eslint-disable-next-line no-alert
		alert(`下載檔案失敗。\n Error message: ${err.message}`);
	}
};

const MapTool = () => {
	const [state, dispatch] = useContext(StoreContext);
	const { map } = state;
	const { isLocNameDisplay, paletteStyle, mapElement, showResultOnExport } = map;

	// local state
	const [mapToolDisplay, setMapToolDisplay] = useState(true);

	// set default palette style from config
	useEffect(() => {
		dispatch({
			type: Act.SET_PALETTE_STYLE,
			paletteStyle: paletteStyleDefault,
		});
	}, [dispatch]);

	// handle marker color style change
	const handlePaletteChange = (e, { value }) => {
		// setPaletteStyle(value);
		dispatch({
			type: Act.SET_PALETTE_STYLE,
			paletteStyle: value,
		});
	};

	return (
		<div className="maps-tool-legend">
			{/* label for toggle tools-div display */}
			{/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-element-interactions */}
			<label
				htmlFor="map-tool-toggle"
				className="map-tool-toggle-label"
				onClick={() => setMapToolDisplay(!mapToolDisplay)}
			>
				<Icon name="options" size="large" className="map-tool-toggle-icon" />
			</label>
			<input
				type="checkbox"
				id="map-tool-toggle"
				className="map-tool-toggle-checkbox"
				defaultChecked={mapToolDisplay}
			/>

			{/* map tools box */}
			<div className="tool-legend-groups">
				{/* export tool */}
				<div className="tool-group">
					<h5>Export</h5>
					<Button
						color="blue"
						icon
						onClick={() =>
							exportImageHandler(mapElement.container, {
								dispatch,
							})
						}
						size="mini"
					>
						Export Image
					</Button>
				</div>
				<div className="tool-group">
					<h5>Display Options</h5>
					<Checkbox
						// toggle
						label="location"
						className="option-item"
						checked={isLocNameDisplay}
						onChange={(e, { checked }) => {
							if (!checked) {
								dispatch({
									type: Act.DISPLAY_LOC_NAME,
									isLocNameDisplay: false,
								});
							} else {
								dispatch({
									type: Act.DISPLAY_LOC_NAME,
									isLocNameDisplay: true,
								});
							}
						}}
					/>
					<Checkbox
						className="option-item"
						label="search results"
						// toggle
						checked={showResultOnExport}
						onChange={(e, { checked }) => {
							if (!checked) {
								dispatch({
									type: Act.SET_SHOW_RESULT_EXPORT,
									showResultOnExport: false,
								});
							} else {
								dispatch({
									type: Act.SET_SHOW_RESULT_EXPORT,
									showResultOnExport: true,
								});
							}
						}}
					/>
				</div>

				{/* legend group */}
				<div className="legend-group">
					<h5>Marker color</h5>
					<Form>
						{markerPaletteStyle &&
							markerPaletteStyle.map((m) => (
								<Form.Radio
									key={m.id}
									label={m.color}
									name="marker-palette-style"
									value={m.color}
									checked={m.color === paletteStyle}
									onChange={handlePaletteChange}
								/>
							))}
					</Form>
					<div className="point-marker-palette">
						{pointMarkerPalette &&
							pointMarkerPalette[paletteStyle] &&
							pointMarkerPalette[paletteStyle].map((item) => (
								<div className="palette-item" key={`palette-${item.id}`}>
									<div className="color-block-container">
										<div className="color-block" style={{ background: item.color }} />
									</div>
									<div className="color-block-description">{item.pubsRange}</div>
								</div>
							))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MapTool;
